// extracted by mini-css-extract-plugin
export default {"outer":"_jjew","container":"fJosj","text":"bguxJ","button":"O8ewt"};